import React, {useRef, useState} from "react";
import {Button, Form} from "react-bulma-components";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableNumberCell from "../../hooks/useEditableTableNumberCell";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import MovementRatePicker from "./MovementRatePicker";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import axios from "axios";
import FAIcon from "../Icon/FAIcon";
import MovementTypePicker from "../Settings/MovementType/MovementTypePicker";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import useEditableTableTimeCell from "../../hooks/useEditableTableTimeCell";
import DriverPicker from "../Settings/Driver/DriverPicker";
import DepartmentPicker from "../Job/DepartmentPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import PrintMovementNote from "./PrintMovementNote";
import ReactToPrint from "react-to-print";
import DeleteConfirmModal from "./DeleteConfirmModal";
import useButtonSelect from "../../hooks/useButtonSelect";
import PrintOptionsModal from "./PrintOptionsModal";


const AsyncTypeahead = asyncContainer(Typeahead);

export default function MovementRow({movement, onDelete, onChange, index, onSave, rateOptions, onRateChange, view,
                                        quoteToMovement, onComplete, movementTypes, movementTypeObjects, endpoint, disabled,
                                    selected, onSelectCheck, isJob, driverOptions, driverObjects, departments, departmentObjects}){
    const [editable, setEditable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [printOptionsOpen, setPrintOptionsOpen] = useState(false);
    const [typeahead, setTypeahead] = useState();
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);


    const handleDelete = () => {
        onDelete(movement);
        setDeleteConfirmOpen(false);
    }

    const supplierStatusOptions = [
        {name: "Internal", value: "INTERNAL"},
        {name: "External", value: "EXTERNAL"}
    ];

    const [supplierStatus, supplierStatusInput] = useButtonSelect({
        initialValue: movement.supplier_status,
        prop: "supplier_status",
        options: supplierStatusOptions,
        callback: (e) => onChange(e, index),
        disabled: !editable
    });


    const getColor = () => {
        if(movement.work_complete){
            return "table-highlight-green"
        }
        else if(movement.job){
            return "colored"
        }
        else if(movement.movement_type && (movement.movement_type.name === "ONHIRE" || movement.movement_type.name === "OFFHIRE")){
            return "table-highlight-orange"
        }
        else if(movement.rental) {return "table-highlight-orange"}
        else{
            return "table-highlight-dark-red"
        }
    }
    let color = getColor();

    const onCheck = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !movement[e.target.name]
            }
        }
        onChange(toUpdate, index)
    }

    const getSource = () => {
        if(movement.job){
            return "JOB"
        }
        else if(movement.rental){
            return "RENTAL"
        }
        else{
            return "USER CREATED"
        }
    }

    const onRowClick = () =>{
        // if(movement.job){
        //     window.open("/editjob/"+movement.job.id, "_self");
        // }
        // else if(movement.rental){
        //     window.open("/editrental/"+movement.rental.id, "_self");
        // }
        window.open("/editmovement/"+movement.id, "_self");
    }
    const overrideOptions = [
        {name:"No", value: false},
        {name:"Yes", value: true}
    ];

    const onTypeChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: movementTypeObjects[e.target.value]
            }
        };
        onChange(toUpdate, index);
    };

    const onDepartmentChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onCostOverrideChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !movement[e.target.name]
            }
        };
        onChange(toUpdate, index);
    }

    const onDriverChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: driverObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onVehicleUsedChange = e => {
        const toUpdate = {
            target: {
                name:"vehicle_used",
                value: e[0]
            }
        };
        onChange(toUpdate, index);
    };


    const onSupplierChange = e => {
        const toUpdate = {
            target: {
                name: "external_supplier",
                value: e[0]
            }
        };
        onChange(toUpdate, index)
    }

    const onSelect = e => {
        e.stopPropagation();
        onSelectCheck(movement);
    };
    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const onCustomerChange = e => {
        const toUpdate = {
            target: {
                name:"customer",
                value: e[0]
            }
        };
        onChange(toUpdate, index);
    };

    const handleCustomerSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=CC&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const handleSupplierSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=SP&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    }

    const getClickableClass = () => {
        if(movement.job || movement.rental){
            return " clickable"
        }
        else{
            return " "
        }
    }

    let rows = []
    const firstRow = (
        <tr
            key={movement.id} className={color + getClickableClass()}
            onClick={onRowClick}
        >
            <td>
                {useEditableTableTextCell({
                    propName: "id",
                    value: movement.id,
                    disabled: true
                })}
            </td>
            <td>
                <DepartmentSelector
                    name={"department"}
                    inlineEdit={!disabled}
                    blank={false}
                    setEditable={setEditable}
                    editable={editable}
                    value={movement.department}
                    options={departments}
                    onSave={() => {
                            onSave(movement);
                            setEditable(false);
                    }}
                    onChange={onDepartmentChange}
                    classname={""}
                    disabled={disabled || !editable}
                />
            </td>
            <td>
                {useEditableTableTextCell({
                    propName: "vehicle",
                    value: movement.vehicle,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: false,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "start_address",
                    value: movement.start_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "end_address",
                    value: movement.end_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableDateCell({
                    propName: "delivery_date",
                    value: movement.delivery_date,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {
                    useEditableTableTextCell({
                        propName: "creator",
                        value: movement.creator ? movement.creator.first_name + " " + movement.creator.last_name : ""
                    })
                }
            </td>
            <td onClick={e => e.stopPropagation()}>
                <Form.Checkbox
                    name={"work_complete"}
                    checked={movement.work_complete}
                    disabled={disabled || !editable}
                    onChange={e => onCheck(e,index)}
                />
            </td>
            {(!(movement.movement_status === "QUOTE") && !isJob) ?
                <td onClick={e => e.stopPropagation()} className={"wide-column"}>
                    <Form.Field>
                        <Form.Control className="table-checkbox">
                            <Form.Checkbox
                                checked={selected}
                                type="checkbox"
                                onClick={onSelect}
                                readOnly
                            />
                        </Form.Control>
                    </Form.Field>
                </td> : <td></td>
            }
            <td onClick={e => e.stopPropagation()}>
                <Button
                    onClick={() => setDeleteConfirmOpen(true)}
                    disabled={movement.completed}
                    color={"danger"}
                >
                    X
                </Button>
            </td>
            {(!movement.completed && !(movement.movement_status === "QUOTE")) ?
                <td onClick={e => e.stopPropagation()}>
                    <Button
                        color={"success"}
                        onClick={() => {
                            onComplete(movement, index);
                        }}
                    >
                        <FAIcon size="small" icon={["fas", "check"]}/>
                    </Button>
                </td> : <td></td>
            }
            {view === "QUOTE" && movement.movement_status === "QUOTE" &&
                <td>
                    <Button
                        onClick={() => quoteToMovement(movement)}
                        color={"success"}
                    >
                        Movement
                    </Button>
                </td>
            }
            <DeleteConfirmModal
                onDelete={handleDelete}
                open={deleteConfirmOpen}
                setOpen={setDeleteConfirmOpen}
            />
        </tr>
    );
    rows.push(firstRow);
    const secondRow = (
        <tr
            className={color}
        >
           <th className={color}>Start Time</th>
           <th className={color}>Time To Be Completed By</th>
           <th className={color}>Customer</th>
           <th className={color}>Order Number</th>
           <th className={color}>Movement Type</th>
           <th className={color}>Movement Rate</th>
           <th className={color}>Distance (Miles)</th>
           <th className={color}>Cost Per Mile</th>
           <th className={color}>Customer Charge</th>
           <th className={color}>Cost Override</th>
           <th className={color}></th>
        </tr>
    )
    rows.push(secondRow)
    const thirdRow = (
        <tr
            className={color}
        >
            <td>
                {useEditableTableTimeCell({
                    propName: "start_time",
                    value: movement.start_time,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTimeCell({
                    propName: "end_time",
                    value: movement.end_time,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td onClick={e => e.stopPropagation()}>
                <AsyncTypeahead
                    useCache={false}
                    isLoading={loading}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"customer"}
                    onSearch={handleCustomerSearch}
                    onChange={onCustomerChange}
                    placeholder={`Search Customer`}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    disabled={!editable || disabled}
                    selected={movement.customer && movement.customer.id ? [movement.customer] : []}
                />
            </td>
            <td>
                {useEditableTableTextCell({
                    propName: "order_number",
                    value: movement.order_number,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                <MovementTypePicker
                    editable={editable}
                    setEditable={setEditable}
                    inlineEdit={!disabled}
                    disabled={!editable || disabled}
                    options={movementTypes ?? {results: []}}
                    onSave={() => {
                        onSave(movement);
                        setEditable(false);
                    }}
                    value={movement.movement_type}
                    onChange={onTypeChange}
                />
            </td>
            <td>
                {
                    <MovementRatePicker
                        editable={editable}
                        setEditable={setEditable}
                        movement={movement}
                        options={rateOptions ?? {results: []}}
                        onChange={(e) => onRateChange(e, index)}
                        onSave={() => {
                            onSave(movement);
                            setEditable(false);
                        }}
                        inlineEdit={!disabled}
                        disabled={!editable || disabled}
                        blank={true}
                    />
                }
            </td>
            <td>
                {useEditableTableNumberCell({
                    propName: "miles",
                    value: movement.miles,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    value: movement.movement_rate ? movement.movement_rate.cost_per_mile : 0,
                    disabled: true,
                    editable,
                    setEditable,
                    inlineEdit: false,
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "cost",
                    value: movement.cost,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                <Form.Field className={"has-addons"}>
                    <Form.Control>
                        <Form.Select
                            onChange={onCostOverrideChange}
                            disabled={!editable || disabled}
                            value={movement.cost_override}
                            name={"cost_override"}
                        >
                            {overrideOptions.map(item => (
                                <option key={item.name} value={item.value}>
                                    {item.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Control>
                    {useInlineEditButton({
                        show: true,
                        onSave: () => {
                            onSave(movement);
                            setEditable(false)
                        },
                        setEditable,
                        editable,
                        disabled: disabled
                    })}
                </Form.Field>
            </td>
            <td>
                <Button
                    color={"warning"}
                    onClick={() => setPrintOptionsOpen(true)}
                >
                    Print
                </Button>
            </td>
        </tr>
    )
    rows.push(thirdRow);
    const forthRow = (
        <tr className={"table-highlight-gray"}>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    )
    rows.push(forthRow);
    const fithRow = (
        <tr
            className={color}
        >
            <th className={color}>Supplier Status</th>
            <th className={color}>Supplier</th>
            {movement.supplier_status === "EXTERNAL" && <th className={color}>External Supplier</th>}
            <th className={color}>Vehicle Used for Movement</th>
            <th className={color}>Driver</th>
            <th className={color}>Internal Charge Cost Override</th>
            <th className={color}>Internal Charge</th>
            {movement.supplier_status === "EXTERNAL" && <th className={color}>External Supplier Charge Override</th>}
            {movement.supplier_status === "EXTERNAL" && <th className={color}>External Supplier Charge</th>}
            <th className={color}>Comments</th>
            <th className={color}>Rate Comments</th>
            {movement.supplier_status !== "EXTERNAL" && <th className={color}></th>}
            {movement.supplier_status !== "EXTERNAL" && <th className={color}></th>}
            {movement.supplier_status !== "EXTERNAL" && <th className={color}></th>}
        </tr>
    );
    rows = rows.concat(fithRow);
    const sixthRow = (
        <tr
            className={color}
        >
            <td>
                {supplierStatusInput}
            </td>
            <td>
                <DepartmentSelector
                    name={"movement_performer"}
                    inlineEdit={!disabled}
                    blank={true}
                    setEditable={setEditable}
                    editable={editable}
                    value={movement.movement_performer}
                    options={departments}
                    onSave={() => {
                            onSave(movement);
                            setEditable(false);
                    }}
                    onChange={onDepartmentChange}
                    classname={""}
                    disabled={disabled || !editable}
                />
            </td>
            {movement.supplier_status === "EXTERNAL" &&
            <td>
                <AsyncTypeahead
                    useCache={false}
                    isLoading={loading}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"external_supplier"}
                    onSearch={handleSupplierSearch}
                    onChange={onSupplierChange}
                    placeholder={`Search Supplier`}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    disabled={!editable || disabled}
                    selected={movement.external_supplier && movement.external_supplier.id ? [movement.external_supplier] : []}
                />
            </td>
            }
            <td onClick={e => e.stopPropagation()}>
                <AsyncTypeahead
                    useCache={false}
                    isLoading={loading}
                    id="typeahead"
                    labelKey="registration"
                    minLength={2}
                    name={"vehicle_used"}
                    onSearch={handleVehicleSearch}
                    onChange={onVehicleUsedChange}
                    placeholder={`Search Vehicle`}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    disabled={!editable || disabled}
                    selected={movement.vehicle_used && movement.vehicle_used.id ? [movement.vehicle_used] : []}
                />
            </td>
            <td>
                <DriverPicker
                    options={driverOptions ?? {results: []}}
                    inlineEdit={!disabled}
                    blank={true}
                    disabled={!editable || disabled}
                    editable={editable}
                    setEditable={setEditable}
                    onChange={onDriverChange}
                    value={movement.driver}
                    onSave={() => {onSave(movement, index); setEditable(false)}}
                />
            </td>
            <td>
                <Form.Field className={"has-addons"}>
                    <Form.Control>
                        <Form.Select
                            onChange={onCostOverrideChange}
                            disabled={!editable || disabled}
                            value={movement.supplier_cost_override}
                            name={"supplier_cost_override"}
                        >
                            {overrideOptions.map(item => (
                                <option key={item.name} value={item.value}>
                                    {item.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Control>
                    {useInlineEditButton({
                        show: true,
                        onSave: () => {
                            onSave(movement);
                            setEditable(false)
                        },
                        setEditable,
                        editable,
                        disabled: disabled
                    })}
                </Form.Field>
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "internal_charge",
                    value: movement.internal_charge,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            {movement.supplier_status === "EXTERNAL" &&
                <td>
                    <Form.Field className={"has-addons"}>
                        <Form.Control>
                            <Form.Select
                                onChange={onCostOverrideChange}
                                disabled={!editable || disabled}
                                value={movement.external_supplier_charge_override}
                                name={"external_supplier_charge_override"}
                            >
                                {overrideOptions.map(item => (
                                    <option key={item.name} value={item.value}>
                                        {item.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Control>
                    </Form.Field>
                </td>
            }
            {movement.supplier_status === "EXTERNAL" &&
                <td>
                    <Form.Input
                        disabled={!editable || disabled}
                        name={"external_supplier_charge"}
                        value={movement.external_supplier_charge}
                        onChange={e => onChange(e, index)}
                        type={"number"}
                    />
                </td>
            }
            <td>
                {useEditableTableTextAreaCell({
                    propName: "comments",
                    value: movement.comments,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    value: movement.movement_rate ? movement.movement_rate.comments : "",
                    disabled: true,
                    editable,
                    setEditable,
                    inlineEdit: false
                })}
            </td>
            {movement.supplier_status !== "EXTERNAL" && <td></td>}
            {movement.supplier_status !== "EXTERNAL" && <td></td>}
            {movement.supplier_status !== "EXTERNAL" && <td></td>}
        </tr>
    )
    rows = rows.concat(sixthRow);
    const seventhRow = (
        <tr className={"table-highlight-black"}>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
        </tr>
    );
    rows = rows.concat(seventhRow);
    const extra = (
        <PrintOptionsModal
            movement={movement}
            setOpen={setPrintOptionsOpen}
            open={printOptionsOpen}
        />
    )
    rows.push(extra);
    return rows;
}